import InventoryTable from "models/backoffice/modelComponents/InventoryTable";

import Slide from "models/backoffice/slideDesign/Slide";
import SlideTitle from "models/backoffice/slideDesign/SlideTitle";
import { forwardRef } from "react";

const FundInventorySlide = forwardRef(
  ({ vizInfo, rows, scaleActive, configurationLinks }, ref) => {
    return (
      <Slide slideWidth={1000} scaleActive={scaleActive} loading={!vizInfo}>
        <SlideTitle size={2}></SlideTitle>
        <InventoryTable ref={ref} vizInfo={vizInfo} rows={rows} />
      </Slide>
    );
  },
);

export default FundInventorySlide;
